export default "__VITE_ASSET__Clvsy63c__"